import { render, staticRenderFns } from "./AddHistory.vue?vue&type=template&id=4181bd88&scoped=true"
import script from "./AddHistory.vue?vue&type=script&lang=js"
export * from "./AddHistory.vue?vue&type=script&lang=js"
import style0 from "./AddHistory.vue?vue&type=style&index=0&id=4181bd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181bd88",
  null
  
)

export default component.exports